export default {
  authStatus: state => state.status,
  isLoggedIn: state => !!state.token
}
